// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

common.View.create('vacancy::canvas.blocks.custom.parallaxSlider.Block', {
    onDOMLoad() {
        this.initSwiper();
        //this.initSlideTextUp();
    },

    initSlideTextUp()
    {
        const $target = $('.slide-up-text');
        const windowHeight = $(window).height();

        $(window).on('scroll', function() {
            const scrollPos = $(this).scrollTop();
            const elementPos = $target.offset().top;
            const elementHeight = $target.outerHeight();

            // Check if the element is within the viewport
            if (elementPos < scrollPos + windowHeight && elementPos + elementHeight > scrollPos) {
                setTimeout(() => {
                    $target.removeClass('translate-y-[250%]').addClass('translate-y-0');
                }, 500);
                $(this).off('scroll'); // Remove the event listener once the animation is triggered
            }
        });

        // const observer = new IntersectionObserver((entries, observer) => {
        //     entries.forEach(entry => {
        //         if (entry.isIntersecting) {
        //             setTimeout(() => {
        //                 entry.target.classList.add('slide-up');
        //             }, 500);
        //             observer.unobserve(entry.target);
        //         }
        //     });
        // }, { threshold: 0.5 }); // Adjust threshold as needed
        //
        // const target = document.querySelector('.slide-up-text');
        // if (target) {
        //     observer.observe(target);
        // }
    },

    initSwiper() {
        new Swiper('.parallaxSlider', {
            breakpoints: {
                320: {
                    slidesPerView: 1.5,
                    spaceBetween: 25,
                },
                768: {
                    slidesPerView: 'auto',
                    spaceBetween: 25,
                },
            },
            navigation: {
                nextEl: ".swiper-button-next-custom",
                prevEl: ".swiper-button-prev-custom",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    },
});
